import { render, staticRenderFns } from "./GlobalMessage.vue?vue&type=template&id=74383c6e&"
import script from "./GlobalMessage.vue?vue&type=script&lang=js&"
export * from "./GlobalMessage.vue?vue&type=script&lang=js&"
import style0 from "./GlobalMessage.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-a9dd69dad6/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports